import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';

/**
 * TravelAgencyFilter Component
 *
 * This component is a filter used to select travel agencies from a list of
 * affiliated agencies.
 *
 * It is displayed under specific conditions:
 * - The user must be affiliated with multiple travel agencies.
 * - The user must have admin privileges.
 * - The user must be on their primary travel agency account.
 *
 * When the user selects specific agencies, it triggers a search
 * to filter trips based on the chosen travel agency IDs.
 */

const TravelAgencyFilter = ({ onSearch }) => {
  const { tripsSearch = {} } = useSelector((store) => store.trip);
  const { travelAgency = {} } = useSelector((store) => store.user);
  const isPrimaryTravelAgencyForUser = !!travelAgency.isPrimaryTravelAgencyForUser;
  const label = 'Travel Agency';
  const options = tripsSearch.filterObj && tripsSearch.filterObj.affiliatedAgencies;
  const doShowFilter = !!(
    options &&
    Array.isArray(options) &&
    options.length > 0 &&
    isPrimaryTravelAgencyForUser
  );

  const handleChange = useCallback(
    (selectedAgenciesIds) => {
      const selectedTravelAgenciesIds = selectedAgenciesIds || [];
      const searchObj = {
        ...tripsSearch.searchObj,
        filterTravelAgencyIds: selectedTravelAgenciesIds,
        page: 1,
      };
      onSearch(searchObj, tripsSearch.searchObj);
    },
    [onSearch, tripsSearch],
  );

  return doShowFilter ? (
    <CheckboxSelectFilter
      options={options}
      values={tripsSearch.searchObj.filterTravelAgencyIds || []}
      onChange={handleChange}
      label={label}
      widthInside="max-w-85"
      variant="outline"
      filterMaxWidthClass="max-w"
    />
  ) : (
    <></>
  );
};

TravelAgencyFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default TravelAgencyFilter;
